import { useCallback } from "react";
import { usePreference } from "./use-preference";
import { getSelectedTenantId } from "@/lib/tenant-selection";

export type RecentPage = {
  href: string;
  label: string;
  emoji?: string;
};

const MAX_RECENT = 5;

export function useRecentPages() {
  const tenantId = getSelectedTenantId() ?? "default";
  const prefKey = `recent-pages-v1:${tenantId}`;
  const [recentPages, setRecentPages] = usePreference<RecentPage[]>(prefKey, []);

  const recordPage = useCallback(
    (href: string, label: string, emoji?: string) => {
      setRecentPages((prev) => {
        const withoutCurrent = prev.filter((p) => p.href !== href);
        return [{ href, label, emoji }, ...withoutCurrent].slice(0, MAX_RECENT);
      });
    },
    [setRecentPages],
  );

  return { recentPages, recordPage };
}
